import { render, staticRenderFns } from "./AcceptedVisits.vue?vue&type=template&id=06ef3db0"
import script from "./AcceptedVisits.vue?vue&type=script&lang=ts"
export * from "./AcceptedVisits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ef3db0')) {
      api.createRecord('06ef3db0', component.options)
    } else {
      api.reload('06ef3db0', component.options)
    }
    module.hot.accept("./AcceptedVisits.vue?vue&type=template&id=06ef3db0", function () {
      api.rerender('06ef3db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/AcceptedVisits.vue"
export default component.exports